// Scoring utility functions for SendItMaxx

// Level progression table
const LEVELS = [
  { min: 0,   max: 49,       title: "OVERTHINKER",  color: "text-gray-400",   bg: "from-gray-800 to-gray-900",    color1: "#6b7280", color2: "#374151", message: "Still thinking too much" },
  { min: 50,  max: 99,       title: "HESITATOR",    color: "text-orange-400", bg: "from-orange-600 to-red-700",   color1: "#fb923c", color2: "#dc2626", message: "At least you're moving" },
  { min: 100, max: 199,      title: "SENDER",       color: "text-yellow-400", bg: "from-yellow-500 to-orange-600",color1: "#fbbf24", color2: "#ea580c", message: "Now we're talking" },
  { min: 200, max: 349,      title: "SENDITMAXXER", color: "text-lime-400",   bg: "from-lime-500 to-green-600",   color1: "#a3e635", color2: "#16a34a", message: "You're actually doing it" },
  { min: 350, max: 499,      title: "UNHINGED",     color: "text-purple-400", bg: "from-purple-600 to-pink-600",  color1: "#c084fc", color2: "#db2777", message: "Most people quit before this" },
  { min: 500, max: Infinity, title: "UNSTOPPABLE",  color: "text-yellow-300", bg: "from-yellow-400 to-orange-500",color1: "#fde047", color2: "#f97316", message: "Top 1%. Keep going." },
];

/**
 * Returns level info for a given score.
 * @param {number} score
 * @returns {{ currentLevel: object, nextLevel: object|undefined, progress: number }}
 */
export const getLevelInfo = (score) => {
  const currentLevel = LEVELS.find(l => score >= l.min && score <= l.max);
  const nextLevel = LEVELS.find(l => l.min > score);
  const progress = nextLevel
    ? Math.min(((score - currentLevel.min) / (nextLevel.min - currentLevel.min)) * 100, 100)
    : 100;

  return { currentLevel, nextLevel, progress };
};

/**
 * Reddit-style hot score — balances upvotes with post age.
 * @param {{ votes: number, timestamp: number }} post
 * @returns {number}
 */
export const hotScore = (post) => {
  const ageHours = (Date.now() - post.timestamp) / 3600000;
  return (post.votes + 1) / Math.pow(ageHours + 2, 1.5);
};
